const locale = {
	// #region Marketing Actions fields
	DETAILS_MARKETINGACTIONS_FIELD_TITLE: 'Titolo',
	DETAILS_MARKETINGACTIONS_FIELD_STATUS: 'Stato Azione Marketing',
	DETAILS_MARKETINGACTIONS_FIELD_TYPE: 'Tipo Azione Marketing',
	DETAILS_MARKETINGACTIONS_FIELD_ASSIGNED_USER: 'Utente assegnato interno',
	DETAILS_MARKETINGACTIONS_FIELD_ASSIGNED_USER_2: 'Utente assegnato esterno',
	DETAILS_MARKETINGACTIONS_FIELD_DATE_FROM: 'Data inizio',
	DETAILS_MARKETINGACTIONS_FIELD_DATE_TO: 'Data fine',
	DETAILS_MARKETINGACTIONS_FIELD_PROGRESS: 'Progresso',
	DETAILS_MARKETINGACTIONS_FIELD_WARNING: 'Warning',
	DETAILS_MARKETINGACTIONS_FIELD_BLOCKED: 'Bloccato',
	DETAILS_MARKETINGACTIONS_FIELD_TAGS: 'Tag',
	DETAILS_MARKETINGACTIONS_FIELD_EXPENSES: 'Spese',
	// #endregion

	// #region Marketing Actions details right sidebar
	MARKETINGACTIONS_STATS_SECTION: 'Statistiche',
	MAAC_STATISTICS_VALUE_EXPENSES: 'Spese',
	MAAC_STATISTICS_VALUE_PLANNED: 'Valore Opportunità',
	MAAC_STATISTICS_N_OPPORTUNITIES: 'N° Opportunità',
	MAAC_STATISTICS_N_LEADS: 'Nuovi Lead',
	MAAC_STATISTICS_N_CUSTOMERS: 'Nuovi Clienti',
	MAAC_STATISTICS_LEAD_CONVERSION: 'Rateo Conversione Lead',
	MAAC_STATISTICS_CAC: 'Costo Acquisizione Cliente (CAC)',
	MAAC_STATISTICS_CPA: 'Costo per Azione (CPA)',
	// #endregion

	// #region Details MarketingAction Add Rows section
	MAAC_SECTION_ADD_TITLE: 'Aggiungi alla lista',
	MAAC_SECTION_ADD_DESCRIPTION_COMPANIES:
		"Aggiungi alla lista un'Azienda nuova o già conosciuta che ha partecipato a questa Azione di Marketing (se non presente verrà anche aggiunta automaticamente al database e sarà disponibile per l'utilizzo in qualsiasi azione di recall in futuro).",
	MAAC_SECTION_ADD_DESCRIPTION_PEOPLE:
		"Aggiungi alla lista una Persona nuova o già conosciuta che ha partecipato a questa Azione di Marketing (se non presente verrà anche aggiunta automaticamente al database e sarà disponibile per l'utilizzo in qualsiasi azione di recall in futuro).",

	MAAC_SECTION_ADD_COMPANIES_TITLE: 'Aggiungi Aziende filtrate',
	MAAC_SECTION_ADD_PEOPLE_TITLE: 'Aggiungi Persone filtrate',

	MAAC_SECTION_COPY_TITLE: 'Importa da',
	MAAC_SECTION_COPY_MARKETINGACTION: 'Azione di Marketing',
	MAAC_SECTION_COPY_DEM: 'DEM',
	MAAC_SECTION_COPY_COMMERCIALCAMPAIGN: 'Campagna Commerciale',

	MAAC_DIALOG_TITLE_ADD_RESULT: 'Vuoi aggiungere questi elementi?',
	// #endregion

	// #region Details MarketingAction Delete Rows section
	MAAC_SECTION_EMPTY_TITLE: 'Svuota la lista',
	MAAC_SECTION_EMPTY_DESCRIPTION:
		'Tramite questa funzione puoi svuotare tutta la lista (eliminando TUTTI gli elementi aggiunti)',
	MAAC_SECTION_EMPTY_BUTTON_CLEAR: 'Svuota'
	// #endregion
};

export default locale;
